// Centralised brand accessor. Imports the vendored branding.json (synced from
// ~/source/sooth-branding/) at build time. To change a brand value, edit
// sooth-branding/branding.json and run ./scripts/sync-branding.sh from this
// repo.
import branding from "../../branding/branding.json";

export const { company, product, links, assets, colors } = branding;

// Convenience helper for asset URLs. Assets are served from /branding/assets/
// at runtime — see vite.config.js.
export const assetUrl = (filename) => `/branding/assets/${filename}`;

export default branding;
